module.exports = __webpack_public_path__ + "img/a3.5ea7a9df.png";